<section id="login" class="bg-dark d-flex align-items-center justify-content-center min-vh-100 py-4">
  <div class="container z-2">
    <div class="row">
      <div class="col-sm-10 col-lg-6 col-xl-5 mx-auto text-center">
        <div id="sun">
          <img src="/images/face.webp" alt="" class="img-fluid w-100 face">
          <img src="/images/sun.webp" alt="" class="img-fluid w-100 sun">
        </div>
        <img src="/images/gizmo.webp" alt="" class="gizmo mb-2" loading="lazy">
        <p class="slogan lh-1">Gateway Initiative for Zodiac and Mystic Offers</p>
        <div class="card shadow-lg position-relative p-sm-4 border-0 fade-in-zoom">
          <div class="card-body text-center">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
